<template>
  <div v-if="access.links.length" class="m21h" :class="{ 'm21h--compact': compact }" data-testid="misura21-home-block">
    <template v-if="compact">
      <span class="m21h-badge">SRH01</span>
      <div class="m21h-links">
        <button
          v-for="(l, i) in access.links"
          :key="l.id"
          type="button"
          class="m21h-link"
          :class="{ 'm21h-link--primary': i === 0 }"
          @click="router.push(l.to)"
        >
          <AeIcon :name="l.icon" :size="14" /> {{ l.label }}
        </button>
      </div>
    </template>

    <template v-else>
      <div class="m21h-head">
        <span class="m21h-badge">SRH01</span>
        <span class="m21h-title">Consulenza aziendale</span>
      </div>
      <p class="m21h-text">{{ intro }}</p>
      <div class="m21h-actions">
        <AeButton variant="primary" @click="router.push(primary.to)">
          <AeIcon :name="primary.icon" :size="16" /> {{ primary.label }}
        </AeButton>
        <AeButton
          v-for="l in others"
          :key="l.id"
          variant="secondary"
          @click="router.push(l.to)"
        >
          <AeIcon :name="l.icon" :size="16" /> {{ l.label }}
        </AeButton>
      </div>
    </template>
  </div>
</template>

<script setup>
import { computed } from 'vue'
import { useRouter } from 'vue-router'
import { AeButton, AeIcon } from '@aevue/components'
import { useAppStore } from '../../../stores/app.js'
import { getMisura21Access } from '../misura21Access.js'

// Accesso rapido a SRH01 dalla Home: pagine per ruolo (stesse voci della sidebar).
// compact = striscia sopra elenco/dettaglio aziende; altrimenti blocco pieno (Home senza aziende).
defineProps({
  compact: { type: Boolean, default: false },
})

const router = useRouter()
const appStore = useAppStore()

const access = computed(() => getMisura21Access(appStore))
const primary = computed(() => access.value.links[0])
const others = computed(() => access.value.links.slice(1))

const intro = computed(() => {
  const a = access.value
  if (a.isAdmin) return 'Gestisci consulenti, aziende, calendario e report del servizio di consulenza.'
  if (a.isExternal) return 'Consulta lo stato dei servizi, le visite e i report delle aziende.'
  if (a.isAdvisor) return 'Pianifica le visite, compila i report e registra le visite in campo.'
  return 'Consulta le visite e i report della consulenza per la tua azienda.'
})
</script>

<style scoped>
.m21h {
  display: flex;
  flex-direction: column;
  gap: .75rem;
  padding: 1rem 1.1rem;
  border: 1px solid var(--ae-border);
  border-radius: 10px;
  background: var(--ae-surface, #fff);
  text-align: left;
}
.m21h-head {
  display: flex;
  align-items: center;
  gap: .5rem;
}
.m21h-badge {
  flex: none;
  font-size: .7rem;
  font-weight: 700;
  letter-spacing: .05em;
  padding: .15rem .45rem;
  border-radius: 4px;
  background: var(--ae-primary, #4479b1);
  color: #fff;
}
.m21h-title {
  font-weight: 700;
  font-size: 1rem;
}
.m21h-text {
  margin: 0;
  color: var(--ae-muted);
  font-size: .9rem;
}
.m21h-actions {
  display: flex;
  flex-wrap: wrap;
  gap: .5rem;
}

.m21h--compact {
  flex-direction: row;
  align-items: center;
  flex-wrap: wrap;
  gap: .5rem .75rem;
  padding: .5rem .75rem;
  margin-bottom: .75rem;
}
.m21h-links {
  display: flex;
  flex-wrap: wrap;
  gap: .35rem;
}
.m21h-link {
  display: inline-flex;
  align-items: center;
  gap: .3rem;
  padding: .25rem .6rem;
  border: 1px solid var(--ae-border);
  border-radius: 999px;
  background: none;
  color: inherit;
  font: inherit;
  font-size: .82rem;
  cursor: pointer;
}
.m21h-link:hover {
  border-color: var(--ae-primary, #4479b1);
  color: var(--ae-primary, #4479b1);
}
.m21h-link--primary {
  border-color: var(--ae-primary, #4479b1);
  color: var(--ae-primary, #4479b1);
  font-weight: 600;
}
</style>
